export default {"src":"/_next/static/media/account.157623ff.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};